import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FunctionComponent } from 'react';

type StarCircleProps = {
    className?: string;
};

const StarCircle: FunctionComponent<StarCircleProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'star-circle'}
            viewBox="0 0 250 250"
        >
            <path d="M187.4 102.6l-42.1-4.4-17.2-38.7c-.7-1.6-2.3-2.7-4.1-2.7-1.8 0-3.4 1.1-4.1 2.7l-17.2 38.7-42.1 4.4c-1.8.2-3.3 1.4-3.8 3.1-.6 1.7-.1 3.6 1.3 4.7l31.5 28.3-8.9 41.4c-.4 1.7.3 3.5 1.8 4.6 1.4 1 3.4 1.1 4.9.3l36.7-21.2 36.7 21.2c.7.4 1.5.6 2.3.6.9 0 1.9-.3 2.6-.9 1.4-1 2.1-2.8 1.8-4.6l-8.9-41.4 31.5-28.3c1.3-1.2 1.8-3.1 1.3-4.7-.7-1.7-2.2-2.9-4-3.1zm-36.9 31.2c-1.2 1.1-1.7 2.7-1.4 4.3l7.3 34-30.1-17.4c-.7-.4-1.5-.6-2.3-.6s-1.6.2-2.3.6l-30.1 17.4 7.3-34c.3-1.6-.2-3.2-1.4-4.3l-25.9-23.3 34.6-3.6c1.6-.2 3-1.2 3.7-2.7L124 72.5l14.1 31.8c.7 1.5 2 2.5 3.7 2.7l34.6 3.6-25.9 23.2z" />
            <path d="M125 .1C56.1.1 0 56.2 0 125.1s56.1 125 125 125 125-56.1 125-125S193.9.1 125 .1zm0 241c-64 0-116-52-116-116s52-116 116-116 116 52 116 116-52 116-116 116z" />
        </svg>
    );
};
export default StarCircle;
